import React from "react";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  headerRow: {
    backgroundColor: "rgba(233, 58, 36, 0.04)",
  },
  headerCell: {
    fontWeight: 700,
    fontSize: "0.71rem",
    textTransform: "uppercase",
    letterSpacing: "0.07em",
    color: "rgba(17, 17, 17, 0.55)",
    borderBottom: "2px solid rgba(233, 58, 36, 0.10)",
    paddingTop: theme.spacing(1.75),
    paddingBottom: theme.spacing(1.75),
    whiteSpace: "nowrap",
  },
  sortLabel: {
    fontWeight: 700,
    fontSize: "0.71rem",
    textTransform: "uppercase",
    letterSpacing: "0.07em",
    color: "rgba(17, 17, 17, 0.55) !important",
    "&.MuiTableSortLabel-active": {
      color: `${theme.palette.primary.main} !important`,
    },
    "& .MuiTableSortLabel-icon": {
      color: `${theme.palette.primary.main} !important`,
      opacity: 0.7,
    },
  },
}));

const TableHeader = ({
  order,
  orderBy,
  onRequestSort = () => {},
  headCells,
}) => {
  const classes = useStyles();
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow className={classes.headerRow}>
        {headCells.map((headCell) =>
          headCell.sortable ? (
            <TableCell
              className={classes.headerCell}
              size="small"
              key={headCell.id}
              align="left"
              padding="default"
              sortDirection={orderBy === headCell.id ? order : false}
            >
              <TableSortLabel
                className={classes.sortLabel}
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
              </TableSortLabel>
            </TableCell>
          ) : (
            <TableCell className={classes.headerCell} size="small" key={headCell.id}>
              {headCell.label}
            </TableCell>
          ),
        )}
      </TableRow>
    </TableHead>
  );
};

export default TableHeader;
